module.exports = __webpack_public_path__ + "SP_SPT9-Book-29f1eb10e1555e1aff001ffab14cef65.png";